<template>
  <section id="faq-id" class="faq-section" :class="classObject">
    <SectionHeader title="FREQUENTLY ASKED QUESTIONS" />
    <div class="accordion-wrap">
      <a-collapse v-model="activeKey" expand-icon-position="right">
        <a-collapse-panel
          :header="list.question"
          :key="`${index + 1}`"
          v-for="(list, index) in data"
        >
          <p>{{ list.answer }}</p>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
export default {
  name: "Faq",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    extraClass: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SectionHeader
  },
  data() {
    return {
      activeKey: ["1"]
    };
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  },
  methods: {
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.faq-section {
  .accordion-wrap {
    max-width: 850px;
    margin: 0 auto;
  }
  .ant-collapse {
    border: none;
    .ant-collapse-item {
      border: none;
      box-shadow: none;
      .ant-collapse-header {
        background: #293188;
        font-family: $content-font;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        padding: 15px 30px;
        margin-bottom: 10px;
      }
      .ant-collapse-content {
        border: none;
        .ant-collapse-content-box {
          padding: 10px 30px 20px 30px;
          background: #fbfbfb;
          p {
            font-family: $content-font;
            font-size: 14px;
            line-height: 24px;
            font-weight: 400;
            margin-bottom: 0;
            color: #707070;
          }
        }
      }
    }
  }
  &.no-padding-top {
    padding-top: 0;
  }
  &.no-padding-bottom {
    padding-bottom: 0;
  }
}

@media only screen and (max-width: 991px) {
  .faq-section {
    .accordion-wrap {
      width: 100%;
      padding: 0 40px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .faq-section {
    .ant-collapse {
      .ant-collapse-item {
        .ant-collapse-header {
          font-size: 13px;
        }
        .ant-collapse-content {
          .ant-collapse-content-box {
            p {
              font-size: 11px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 425px) {
  .faq-section {
    .ant-collapse {
      .ant-collapse-item {
        .ant-collapse-header {
          padding: 8px 30px 8px 20px;
        }
        .ant-collapse-content {
          .ant-collapse-content-box {
            padding: 8px 30px 8px 20px;
            p {
              font-size: 11px;
            }
          }
        }
      }
    }
  }
}
</style>
